import React, { useEffect, useState } from 'react';
// import Services from '../services/services';
import { useHistory } from 'react-router-dom';
// import toast from 'react-hot-toast';
import { Container } from '@material-ui/core';
import TopAppBar from '../ui/TopAppBar';
import SideBar from '../ui/SideBar';
// import HomeSharpIcon from '@material-ui/icons/HomeSharp';
import AccountCircleSharpIcon from '@material-ui/icons/AccountCircleSharp';
import EventNoteSharpIcon from '@material-ui/icons/EventNoteSharp';
import GroupSharpIcon from '@material-ui/icons/GroupSharp';
import ListAltIcon from '@material-ui/icons/ListAlt';
import {
  togetherLogo,
  getUserBrowserStorage,
  // clearAllBrowserStorage,
  // removeSessionItem,
} from '../constants';
import { red } from '@material-ui/core/colors';
// import Navbar from '../ui/Navbar';

const title = '2Gathers';
const drawerData = [
  // {
  //   id: '1',
  //   icon: <HomeSharpIcon />,
  //   display: 'Home',
  //   url: '/homepage',
  // },

  // {
  //   id: '2',
  //   icon: <EventNoteSharpIcon />,
  //   display: 'Create Event',
  //   url: '/newevent',
  // },
  {
    id: '3',
    icon: <AccountCircleSharpIcon />,
    display: 'Create Host',
    url: '/newuser',
  },
  {
    id: '4',
    icon: <EventNoteSharpIcon />,
    display: 'Events',
    url: '/',
  },
  {
    id: '5',
    icon: <GroupSharpIcon />,
    display: 'View Users',
    url: '/viewusers',
  },
  {
    id: '6',
    icon: <ListAltIcon />,
    display: 'Email List',
    url: '/emaillist',
  },
];

function HeadBar(props) {
  // const history = useHistory();
  const [headData, setHeadData] = useState([]);
  const [sidebarOpen, setSideBarOpen] = useState(false);
  const loggedIn = getUserBrowserStorage('isLogin');
  const userDetails =
    loggedIn !== 'true' ? {} : JSON.parse(getUserBrowserStorage('userDetails'));

  //set1 for unlogged user
  const set1 = [
    { type: 'normal', display: 'REQUEST A DEMO', url: '/contactinfo' },
    { type: 'normal', display: 'PRICING', url: '/contactinfo' },
    { type: 'normal', display: 'CONTACT US', url: '/contactinfo' },
    { type: 'normal', display: 'EVENTS', url: '/contactinfo' },
    // { type: 'auth', display: 'sign in', url: '/login' },
    // {
    //   type: 'auth',
    //   display: 'sign up free',
    //   url: '/signup',
    // },
  ];

  //set2 for loggedIn user
  const set2 = [
    // { type: 'normal', display: 'Events', url: '/' },
    // { type: 'normal', display: 'CONTACT US', url: '/login' },
    {
      type: 'host',
      display: 'EmailList',
      url: '/emaillist',
    },
    {
      type: 'iconProfile',
      display: `${
        userDetails.firstName
        // + (userDetails.lastName ? ' ' + userDetails.lastName : '')
      }`,
      url: '/myaccount',
    },
    // { type: 'special', display: 'Sign Out', url: '/login', func: logoutFunc },
  ];

  useEffect(() => {
    if (loggedIn === 'true') {
      setHeadData(set2);
      return;
    } else {
      setHeadData(set1);
      return;
    }
  }, [loggedIn]);

  return (
    <Container>
      <TopAppBar
        logo={togetherLogo.logo}
        title={title}
        data={headData}
        centerData={drawerData}
        setSideBarOpen={setSideBarOpen}
        sidebarOpen={sidebarOpen}
        userType={userDetails?.userType}
        userName={userDetails?.firstName}
      />

      {userDetails?.userType === 3 || !userDetails?.userType ? null : (
        <SideBar
          data={drawerData}
          userType={userDetails?.userType}
          sidebarOpen={sidebarOpen}
          setSideBarOpen={setSideBarOpen}
        />
      )}
    </Container>
  );
}

export default HeadBar;
